import { useAppDispatch, useAppSelector } from '../../../../../app/config/store';
import { overridePaginationStateWithQueryParams } from '../../../../../app/shared/util/entity-utils';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from '../../../../../app/shared/util/pagination.constants';
import React, { useEffect, useState } from 'react';
import { getPaginationState, JhiItemCount, JhiPagination, Translate } from 'react-jhipster';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Table, Button, Row, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledTooltip, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { hasAnyAuthority } from 'app/shared/auth/private-route';
// import { getSession } from 'app/shared/reducers/authentication';
// import { AUTHORITIES } from 'app/config/constants';
import { faSort } from '@fortawesome/free-solid-svg-icons/faSort';
import { faFilter, faCircleXmark, faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { getEntities } from '../../entities/case-review/case-review.reducer';

interface Props {
  cardCols?: string;
  handleViews?: any;
  id?: any;
}
export const CasereviewListView = (props: Props) => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const { id } = useParams<'id'>();

  const isNew = id === undefined;

  var list = useAppSelector(state => state.caseReview.entities);
  const loading = useAppSelector(state => state.caseReview.loading);
  const totalItems = useAppSelector(state => state.caseReview.totalItems);

  const [dropdownOpenApp, setDropdownOpenApp] = useState('');
  const [showComponent, setShowComponent] = useState('');
  const [activeItem, setActiveItem] = useState<any>();

  const [query, setQuery] = useState<any>();

  const [showInput, setShowInput] = useState<any>('');

  const [dataList, setDataList] = useState<any>(list);

  const [filterValue, setFilterValue] = useState<any>('');
  const [filterField, setFilterField] = useState<any>('');

  const [toggleDropdown, setToggleDropdown] = useState('');

  const sortFields = ['title', 'aiChatId', 'userId', 'isDeleted', 'step'];
  const filterFields = ['title', 'aiChatId', 'userId', 'isDeleted', 'step'];

  useEffect(() => {
    if (list?.length > 0) {
      setDataList(list);
    }
  }, [list]);

  useEffect(() => {}, []);

  const getAllEntities = (emptyQuery?: any) => {
    const queryValue = emptyQuery != undefined ? emptyQuery : query;

    const filFields = filterField != undefined ? filterField : '';
    const filValue = filterValue != undefined ? filterValue : '';

    if (isNew) {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}${queryValue ? `&title.contains=${queryValue}` : ''}${filFields != '' && filValue != '' ? `&${filFields}.contains=${filValue}` : ''}`,
        }),
      );
    } else {
      dispatch(getEntities({}));
    }
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}${filterValue ? `&filter=${filterValue}` : ''}${query ? `&search=${query}` : ''}`;
    if (location.search !== endURL) {
      navigate(`${location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, query, filterValue]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  let entityFields = ['title', 'aiChatId', 'userId', 'isDeleted', 'step'];

  const handleView = (entity, id) => {};

  const handleEdit = (entity, id) => {};

  const handleQuery = e => {
    setQuery(e.target.value);
    if (!e.target.value) {
      getAllEntities(e.target.value);
    }
  };

  const handleKeyPress = async e => {
    if (e.key === 'Enter') {
      sortEntities();
    }
  };

  const handleSearch = async () => {
    sortEntities();
  };

  const handleFilterQuery = (field, value) => {
    setFilterField(field);
    setFilterValue(value);
  };

  return (
    <div className="inner-content-wrap">
      <Row>
        {/* <h3 className="text-capitalize mb-3">
          Casereview List View
        </h3> */}

        <Col md="12">
          <Row className="searchBar">
            <Col md={8}>
              <div className=" search-position">
                <Input
                  key="search-input"
                  type="text"
                  onChange={handleQuery}
                  placeholder="Search CaseReview"
                  onKeyDown={handleKeyPress}
                  value={query}
                />
              </div>
            </Col>
            <Col md={4} style={{ padding: 0 }}>
              <Button size="md" className="btn-height" onClick={handleSearch} color="save">
                Search
              </Button>
            </Col>
          </Row>

          <div className="table-responsive">
            {dataList ? (
              <Table responsive>
                {dataList.length > 0 && (
                  <>
                    <thead>
                      <tr>
                        {Object.keys(dataList[0])
                          .filter(items => entityFields.includes(items))
                          .map(item => {
                            return (
                              <th className="hand">
                                <div className="tableTh">
                                  {filterFields?.length > 0 && filterFields.includes(item) ? (
                                    showInput == item ? (
                                      <FontAwesomeIcon
                                        icon={faCircleXmark}
                                        style={{ margin: '0px 4px' }}
                                        onClick={() => setShowInput('')}
                                      />
                                    ) : (
                                      <FontAwesomeIcon
                                        icon={faFilter}
                                        style={{ margin: '0px 4px' }}
                                        onClick={() => (showInput == '' ? setShowInput(item) : setShowInput(''))}
                                      />
                                    )
                                  ) : (
                                    ''
                                  )}

                                  {showInput == item ? (
                                    <div className="filter-field">
                                      <Input
                                        className="filter-input"
                                        key="filter-input"
                                        type="text"
                                        onChange={e => handleFilterQuery(item, e.target.value)}
                                        placeholder={`Filter ${item}`}
                                        value={filterValue}
                                      />
                                      <FontAwesomeIcon
                                        icon={faArrowsRotate}
                                        style={{ margin: '0px 4px' }}
                                        onClick={() => setFilterValue('')}
                                      />
                                    </div>
                                  ) : (
                                    <div>
                                      {item.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, str => str.toUpperCase())}
                                      {sortFields?.length > 0 && sortFields.includes(item) && (
                                        <FontAwesomeIcon icon={faSort} style={{ margin: '0px 4px' }} onClick={sort(item)} />
                                      )}
                                    </div>
                                  )}
                                </div>
                              </th>
                            );
                          })}
                      </tr>
                    </thead>
                    <tbody>
                      {dataList.map((obj, i) => (
                        <tr key={`entity - ${i}`} data-cy="entityTable">
                          {Object.entries(obj).map(([key, value]) => {
                            if (entityFields.includes(key)) {
                              return <td>{value as string} </td>;
                            }
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </>
                )}
              </Table>
            ) : (
              !loading && (
                <div className="alert alert-warning">
                  <Translate contentKey="conductorApp.obj.home.notFound">No Products found</Translate>
                </div>
              )
            )}
          </div>
          {totalItems ? (
            <div className={dataList && dataList.length > 0 ? 'footer-pagination' : 'd-none'}>
              <div className="justify-content-end d-flex">
                <JhiItemCount
                  page={paginationState.activePage}
                  total={totalItems}
                  itemsPerPage={paginationState.itemsPerPage}
                  i18nEnabled
                />
              </div>
              <div className="justify-content-end d-flex">
                <JhiPagination
                  activePage={paginationState.activePage}
                  onSelect={handlePagination}
                  maxButtons={5}
                  itemsPerPage={paginationState.itemsPerPage}
                  totalItems={totalItems}
                />
              </div>
            </div>
          ) : (
            ''
          )}
        </Col>
      </Row>
    </div>
  );
};

export default CasereviewListView;
